export default __webpack_public_path__ + "static/media/013-peacock.40f4e54a.svg";